//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['project_id'],
    created: function created() {
        this.getFiles();
        this.getPages();
    },
    mounted: function mounted() {},
    data: function data() {
        var loading = false;
        var columns = [{ class: 'col-md-6', label: 'Folienname', name: 'Folienname', type: 'text', sortable: false }, { class: 'col-md-6', label: 'Datei', name: 'Datei', type: 'text', sortable: false }];
        return {
            matches: [],
            pages: [],
            files: []
        };
    },

    methods: {
        getPages: function getPages() {
            var _this = this;

            this.loading = true;
            var url = route('sanctum_api.projects.projectpages.index', { project: this.project_id });
            axios.get(url).then(function (response) {
                _this.loading = false;
                _this.pages = response.data.data;
            }).catch(function (errors) {
                console.log(errors);
            });
        },
        getFiles: function getFiles() {
            var _this2 = this;

            this.loading = true;
            axios.get(window.location.protocol + "//" + window.location.hostname + "/manage/project/" + this.project_id + "/0/files/2").then(function (response) {
                _this2.files = response.data.data;
                for (var i in _this2.files) {
                    if (_this2.files[i].question_id > 0) {
                        _this2.matches[_this2.files[i].id] = _this2.files[i].page_id + '|' + _this2.files[i].question_id;
                    } else {
                        _this2.matches[_this2.files[i].id] = _this2.files[i].page_id;
                    }
                }
            }).catch(function (errors) {
                console.log(errors);
            });
        },
        sortBy: function sortBy(key) {
            this.sortKey = key;
            this.sortOrders[key] = this.sortOrders[key] * -1;
        },
        getIndex: function getIndex(array, key, value) {
            return array.findIndex(function (i) {
                return i[key] == value;
            });
        },
        save: function save(file_id) {
            var page_id = this.matches[file_id];
            var question_id = 0;

            if (isNaN(page_id) && page_id.includes("|")) {
                question_id = page_id.split('|')[1];
                page_id = page_id.split('|')[0];
            }

            axios({
                method: 'post',
                url: window.location.protocol + "//" + window.location.hostname + "/de/manage/project/updatefile",
                data: {
                    page_id: page_id,
                    question_id: question_id,
                    file_id: file_id }
            }).catch(function (err) {
                console.log("AXIOS ERROR: ", err);
            }).finally(function () {});
        }
    },
    computed: {}
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]]}!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/js/components/Projectfilemanager.vue
// module id = 58
// module chunks = 0